import ClosedAccountsScreen from 'features/statementsAndForms/screens/AccountStatements/ClosedAccountsScreen';
import React from 'react';

export default function ClosedAccountsScreenPage() {
  return <ClosedAccountsScreen />;
}
